<template>
    <div class="card">
        <table class="table text-align-center">
            <thead>
                <tr>
                    <th>CAROTENE INFO</th>
                    <th v-for="n in CaroteneDataInfo.length" :key="'caroteneInfo'+n">{{ n }}</th>
                    <th>MIN</th>
                    <th>MAX</th>
                    <th>MEANS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>carotene</td>
                    <td v-for="(CaroteneData, index) in CaroteneDataInfo" :key="'carotene'+index">{{ CaroteneData.carotene }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ["palmID", "TrialId"],
    data () {
        return {
            CaroteneDataInfo: "",
        };
    },
    mounted() {
        var self = this;
        this.$nextTick(function () {
            self.getCaroteneData();
        });
    },
    methods: {
        getCaroteneData() {
            var self = this;
            axios({
				    method: "GET",
				    url: "CaroteneData/GetAll",
				    params: {
				      PalmId: self.palmID,
				      TrialId: self.TrialId
				    }
            })
                .then(function (response) {
                    self.CaroteneDataInfo = response.data.result.items;
                });
        },
    }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/FieldData/CaroteneInfo.vue